import React from 'react';
import { Phone, PhoneMissed, PhoneOff, Video } from 'lucide-react';
import { useCall } from '../../context/CallContext';
import { useAuth } from '../../context/AuthContext';
import './Calls.css';

// El backend serializa estas llamadas como ChatMessage.content = '[CALL]{...json...}'
const PREFIX = '[CALL]';

export function isCallMessage(content) {
    return typeof content === 'string' && content.startsWith(PREFIX);
}

export function parseCallMessage(content) {
    if (!isCallMessage(content)) return null;
    try {
        return JSON.parse(content.substring(PREFIX.length));
    } catch {
        return null;
    }
}

const formatDuration = (sec) => {
    if (!sec || sec <= 0) return '';
    const mins = Math.floor(sec / 60);
    const secs = sec % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
};

export default function CallMessageBubble({ message, conversation }) {
    const data = parseCallMessage(message?.content);
    const { user } = useAuth();
    const { startCall, status } = useCall();

    if (!data) return null;

    const isOwnSent = message.sender_id === user?.id;
    const isVideo = data.call_type === 'video';
    const isMissed = data.status === 'missed' || data.status === 'rejected' || data.status === 'cancelled';

    const Icon = isMissed
        ? PhoneMissed
        : isVideo
            ? Video
            : Phone;

    let label;
    if (data.status === 'missed') label = isOwnSent ? 'Llamada sin respuesta' : 'Llamada perdida';
    else if (data.status === 'rejected') label = isOwnSent ? 'Rechazada' : 'Llamada rechazada';
    else if (data.status === 'cancelled') label = isOwnSent ? 'Llamada cancelada' : 'Cancelada';
    else label = isVideo ? 'Videollamada' : 'Llamada';

    const duration = data.status === 'ended' ? formatDuration(data.duration) : '';

    const canRedial = !isOwnSent && isMissed && conversation && !conversation.is_group && status === 'idle';
    const handleRedial = () => {
        if (canRedial) startCall(conversation.id, data.call_type || 'video');
    };

    return (
        <button
            type="button"
            className={`call-pill ${isMissed ? 'call-pill-missed' : 'call-pill-ended'} ${canRedial ? 'call-pill-clickable' : ''}`}
            onClick={canRedial ? handleRedial : undefined}
            disabled={!canRedial}
            title={canRedial ? 'Devolver llamada' : ''}
        >
            <span className="call-pill-icon">
                <Icon size={16} />
            </span>
            <span className="call-pill-text">
                <span className="call-pill-label">{label}</span>
                {duration && <span className="call-pill-duration">{duration}</span>}
            </span>
        </button>
    );
}

export { PhoneOff };  // re-export por si luego se usa
